import { render } from "./RatingControl.vue?vue&type=template&id=edbdc7b8&scoped=true"
import script from "./RatingControl.vue?vue&type=script&lang=js"
export * from "./RatingControl.vue?vue&type=script&lang=js"

import "./RatingControl.vue?vue&type=style&index=0&id=edbdc7b8&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbdc7b8"]])

export default __exports__